import { render, staticRenderFns } from "./audit-item-details.vue?vue&type=template&id=13ad18a6&scoped=true"
import script from "./audit-item-details.vue?vue&type=script&lang=js"
export * from "./audit-item-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ad18a6",
  null
  
)

export default component.exports